// @ts-nocheck

import * as R from 'ramda';
import {
  ARCHIVE_FRAUD_AGENT,
  ARCHIVE_FRAUD_RULE,
  CREATE_FRAUD_AGENT,
  CREATE_FRAUD_RULE,
  CREATE_ONCE_EVER_CAP,
  GET_CAPPING_CONFIGURATION,
  GET_FRAUD_AGENTS,
  GET_FRAUD_AGENTS_METRICS,
  GET_FRAUD_AGENT_TEMPLATES,
  GET_FRAUD_RULES,
  REMOVE_ONCE_EVER_CAP,
  UPDATE_CAPPING_CONFIGURATION,
  UPDATE_FRAUD_AGENT,
  UPDATE_FRAUD_RULE,
} from '../actions/FraudActions';
import { LOADING_STATUS } from '../support/constants';
import { reducerWrapper } from '../support/utils';
import type { FraudReducer } from '../types/fraudTypes';
export const INIT_STATE: FraudReducer = {
  loadingStatus: LOADING_STATUS.INIT,
  error: null,
  fraudRules: {},
  cappingConfiguration: {},
  fraudAgents: {},
  fraudAgentTemplates: [],
  fraudAgentsMetrics: {},
};
export function Handler(
  state: FraudReducer = INIT_STATE,
  action: {
    type: string;
    data: any;
  }
) {
  switch (action.type) {
    case GET_FRAUD_RULES.response:
      const fraudRules = R.merge(state.fraudRules, R.indexBy(R.prop('id'), action.data));
      return R.merge(state, {
        fraudRules: fraudRules,
        loadingStatus: LOADING_STATUS.LOADED,
      });

    case UPDATE_FRAUD_RULE.response:
    case CREATE_FRAUD_RULE.response:
    case ARCHIVE_FRAUD_RULE.response:
      const updatedRules = { ...state.fraudRules, [action.data.id]: action.data };
      return R.merge(state, {
        fraudRules: updatedRules,
      });

    case GET_CAPPING_CONFIGURATION.response:
      return R.merge(state, {
        cappingConfiguration: action.data,
        loadingStatus: LOADING_STATUS.LOADED,
      });

    case UPDATE_CAPPING_CONFIGURATION.response:
    case CREATE_ONCE_EVER_CAP.response:
      return R.merge(state, {
        cappingConfiguration: action.data,
      });

    case REMOVE_ONCE_EVER_CAP:
      const remainingCappingConfiguration = R.clone(state.cappingConfiguration);
      delete remainingCappingConfiguration[action.data.cappingEventName];
      return R.merge(state, {
        cappingConfiguration: remainingCappingConfiguration,
      });

    case GET_FRAUD_AGENT_TEMPLATES.response:
      return R.merge(state, {
        fraudAgentTemplates: action.data,
      });

    case GET_FRAUD_AGENTS.response:
      const data = action.data.map((fraudAgent) => {
        return R.merge(fraudAgent, {
          events_to_block: fraudAgent.events_to_block.split(','),
        });
      });
      return R.merge(state, {
        fraudAgents: R.indexBy(R.prop('agent_id'), data),
        loadingStatus: LOADING_STATUS.LOADED,
      });

    case UPDATE_FRAUD_AGENT.response:
    case CREATE_FRAUD_AGENT.response:
    case ARCHIVE_FRAUD_AGENT.response:
      const incomingFraudAgent = R.clone(action.data);
      incomingFraudAgent.events_to_block = incomingFraudAgent.events_to_block.split(',');
      const updatedAgents = { ...state.fraudAgents, [action.data.agent_id]: incomingFraudAgent };
      return R.merge(state, {
        fraudAgents: updatedAgents,
      });

    case GET_FRAUD_AGENTS_METRICS.response:
      const fraudAgentsMetrics = action.data.map((agentMetric) => {
        if (agentMetric.rule_action === 'DELETED') {
          return {
            id: agentMetric.fraud_rule_id,
            app_id: agentMetric.app_id,
            organization_id: agentMetric.organization_id,
            datasource: agentMetric.datasource,
            status: 'ARCHIVED',
            type: 'THRESHOLD',
            rule: agentMetric.rule_text,
            created: agentMetric.created,
            modified: agentMetric.modified,
            modified_by_user: `threshold-rule-${agentMetric.agent_id}`,
            scope: 'POST ATTRIBUTION',
            agent_id: agentMetric.agent_id,
            title: '',
          };
        }

        return {
          id: agentMetric.fraud_rule_id,
          app_id: agentMetric.app_id,
          organization_id: agentMetric.organization_id,
          datasource: agentMetric.datasource,
          status: 'ACTIVE',
          type: 'THRESHOLD',
          rule: agentMetric.rule_text,
          created: agentMetric.created,
          modified: agentMetric.modified,
          modified_by_user: `threshold-rule-${agentMetric.agent_id}`,
          scope: 'POST ATTRIBUTION',
          agent_id: agentMetric.agent_id,
        };
      });
      return R.merge(state, {
        fraudAgentsMetrics: R.indexBy(R.prop('id'), fraudAgentsMetrics),
      });

    default:
      return state;
  }
}
const Fraud = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_FRAUD_RULES, GET_CAPPING_CONFIGURATION, GET_FRAUD_AGENTS, GET_FRAUD_AGENTS_METRICS],
  error: [],
  resetOn: ['APP_CHANGE'],
});
export default Fraud;
